import React from "react"
import { Editor } from "core/editor"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { useActiveBlock } from "app/regions/hooks/use-active-block"
import { useSlateValue } from "app/regions/hooks/use-slate-value"
import { useEditing } from "app/regions/hooks/use-editing"
import { serialize } from "core/editor/serializer"
import { ElementToolbar } from "app/editor/element-toolbar"
import { useInheritedTheme, useTheme } from "@convertkit/editor"

const headings = [
  { type: "heading-one" },
  { type: "heading-two" },
  { type: "heading-three" }
]

const schema = {
  document: {
    nodes: [
      {
        match: [{ type: "paragraph" }, { type: "button" }, ...headings]
      }
    ],
    normalize: (editor, error) => {
      switch (error.code) {
        case "child_type_invalid":
          editor.setNodeByKey(error.child.key, { type: "paragraph" })
          return

        default:
          return
      }
    }
  }
}

export function LiteSlateEditor({ block_id }) {
  const { update, properties } = useBlocks(block_id)
  const editing = useEditing()
  const theme = useTheme()
  const value = useSlateValue(properties.value, update)
  const { activeBlock, setActiveBlockId } = useActiveBlock()
  const { find } = useInheritedTheme()

  if (!editing) {
    const html = value && serialize(value, { theme, find })

    return <div key={block_id} dangerouslySetInnerHTML={{ __html: html }} />
  }

  const handleSelection = event => {
    event.stopPropagation()
    if (block_id !== activeBlock?.block_id) setActiveBlockId(block_id)
  }

  return (
    // Here, we use stopPropagation() to prevent "Space" from bubbling up to
    // the Layout block. Layout blocks are wrapped in <Block>, which have an
    // event handler to focus them on Space for accessibility purposes. If
    // someone presses Space inside of LiteSlateEditor, they're not trying to
    // focus the parent Layout block.
    <div onKeyPress={e => e.stopPropagation()} role="presentation">
      <Editor
        placeholder="Add your content..."
        onChange={({ value }) => update({ value })}
        value={value}
        schema={schema}
        target="email"
        onClick={handleSelection}
      >
        <ElementToolbar />
      </Editor>
    </div>
  )
}
